import {
  type CommercialReceptionBookViewPlan,
  type PurchaseStatusValue,
} from "../types";

/**
 * 「購入済み」「未購入」「全件」の3値ドメイン。
 * フォーム上は独立した2つのチェックボックスで表現されるが、
 * 両方チェック・両方未チェックはどちらも「全件」に縮退するため、
 * 変換後のドメイン値としてはこの3値で扱う。
 */
type PurchaseStatusFilter = "purchased" | "unpurchased" | "all";

/**
 * フォームの2つの独立したチェックボックス値を、3値の購入状況フィルタへ変換する。
 * 両方true・両方falseはいずれも「全件」を意味する。
 * @param {boolean} purchased - 「購入済み」チェックボックスの値
 * @param {boolean} unpurchased - 「未購入」チェックボックスの値
 * @returns {PurchaseStatusFilter}
 */
export const toPurchaseStatusFilter = (
  purchased: boolean,
  unpurchased: boolean
): PurchaseStatusFilter => {
  if (purchased && !unpurchased) return "purchased";
  if (unpurchased && !purchased) return "unpurchased";
  return "all";
};

/**
 * 購入状況フィルタを検索APIへ渡すパラメータへ変換する。
 * 定額課金プラン（flat_monthly）は購入状況フィルタ自体が非表示要件のため、
 * フォーム値が残っていても常に undefined（フィルタなし）を返す。
 * 従量課金プランで「全件」の場合も undefined を返す。
 * @param {CommercialReceptionBookViewPlan} plan - 閲覧プラン
 * @param {PurchaseStatusFilter} filter - 3値の購入状況フィルタ
 * @returns {PurchaseStatusValue[] | undefined}
 */
export const toPurchaseStatusParam = (
  plan: CommercialReceptionBookViewPlan,
  filter: PurchaseStatusFilter
): PurchaseStatusValue[] | undefined => {
  if (plan === "flat_monthly" || filter === "all") return undefined;
  return [filter];
};

export type { PurchaseStatusFilter };
